/* eslint-disable no-use-before-define */
/* eslint-disable react/require-default-props */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useMemo, useState, useId } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Container } from '../../styles/layout/Container';
import {
   PageHeader,
   PageHeaderActions,
   PageHeaderText,
   PageTitle,
   PageSubtitle,
} from '../../styles/layout/PageHeader';
import { Section, SectionTitle } from '../../styles/layout/Section';
import {
   ActionBar,
   ActionBarLeft,
   ActionBarRight,
} from '../../styles/layout/ActionBar';
import { CardGrid } from '../../styles/layout/CardGrid';
import { FormGrid } from '../../styles/layout/FormGrid';
import { TableWrapper } from '../../styles/table/TableWrapper';
import { EmptyState } from '../../styles/feedback/EmptyState';
import { ErrorState } from '../../styles/feedback/ErrorState';

/* Navegação do showcase */
const NavBar = styled.div`
   display: flex;
   align-items: center;
   justify-content: space-between;
   gap: 10px;
   margin-bottom: 14px;
`;

const NavLeft = styled.div`
   display: flex;
   align-items: center;
   gap: 10px;
   min-width: 0;
`;

const NavRight = styled.div`
   display: flex;
   gap: 8px;
   flex-wrap: wrap;
`;

const StepBadge = styled.div`
   font-size: 12px;
   padding: 6px 10px;
   border-radius: 999px;
   border: 1px solid
      ${({ theme }) => theme?.colors?.border ?? 'rgba(0,0,0,0.12)'};
   color: ${({ theme }) => theme?.colors?.textMuted ?? '#666'};
   white-space: nowrap;
`;

const StepTitle = styled.div`
   font-size: 13px;
   color: ${({ theme }) => theme?.colors?.textSecondary ?? '#222'};
   white-space: nowrap;
   overflow: hidden;
   text-overflow: ellipsis;
   max-width: 55vw;
`;

const Divider = styled.div`
   height: 1px;
   background: ${({ theme }) => theme?.colors?.border ?? 'rgba(0,0,0,0.08)'};
   margin: 12px 0;
`;

/* Inputs/Buttons base (somente para vitrine) */
const FieldLabel = styled.span`
   font-size: 12px;
   color: ${({ theme }) => theme?.colors?.textMuted ?? '#666'};
`;

const BaseInput = styled.input`
   height: 38px;
   border-radius: 10px;
   border: 1px solid
      ${({ theme }) => theme?.colors?.border ?? 'rgba(0,0,0,0.16)'};
   padding: 0 10px;
   outline: none;
   background: ${({ theme }) => theme?.colors?.surface ?? '#fff'};
   color: ${({ theme }) => theme?.colors?.textPrimary ?? '#111'};

   &:focus {
      border-color: ${({ theme }) => theme?.colors?.primary ?? '#111'};
      box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.08);
   }
`;

const BaseSelect = styled.select`
   height: 38px;
   border-radius: 10px;
   border: 1px solid
      ${({ theme }) => theme?.colors?.border ?? 'rgba(0,0,0,0.16)'};
   padding: 0 10px;
   outline: none;
   background: ${({ theme }) => theme?.colors?.surface ?? '#fff'};
   color: ${({ theme }) => theme?.colors?.textPrimary ?? '#111'};
`;

const Button = styled.button`
   height: 38px;
   padding: 0 12px;
   border-radius: 10px;
   border: 1px solid
      ${({ theme, $variant }) =>
         $variant === 'solid'
            ? 'rgba(0,0,0,0.12)'
            : theme?.colors?.border ?? 'rgba(0,0,0,0.16)'};
   background: ${({ $variant, theme }) =>
      $variant === 'solid'
         ? theme?.colors?.primary ?? 'rgba(0,0,0,0.85)'
         : 'transparent'};
   color: ${({ $variant }) => ($variant === 'solid' ? '#fff' : 'inherit')};
   cursor: pointer;
   white-space: nowrap;

   &:disabled {
      opacity: 0.55;
      cursor: not-allowed;
   }
`;

function Field({ label, children }) {
   const id = useId();
   if (React.isValidElement(children)) {
      const childId = children?.props?.id ?? id;
      const childWithId = React.cloneElement(children, { id: childId });
      return (
         <label htmlFor={childId} style={{ display: 'grid', gap: 6 }}>
            <FieldLabel>{label}</FieldLabel>
            {childWithId}
         </label>
      );
   }

   return (
      <label style={{ display: 'grid', gap: 6 }}>
         <FieldLabel>{label}</FieldLabel>
         {children}
      </label>
   );
}

Field.propTypes = {
   label: PropTypes.node,
   children: PropTypes.node,
};

const MiniCard = styled.div`
   border: 1px solid
      ${({ theme }) => theme?.colors?.border ?? 'rgba(0,0,0,0.08)'};
   border-radius: 12px;
   padding: 12px;
   background: ${({ theme }) => theme?.colors?.surface ?? '#fff'};
   box-shadow: ${({ theme }) =>
      theme?.shadows?.sm ?? '0 1px 2px rgba(0,0,0,0.04)'};
`;

const MiniCardTitle = styled.div`
   font-size: 12px;
   color: ${({ theme }) => theme?.colors?.textMuted ?? '#666'};
   margin-bottom: 6px;
`;

const MiniCardValue = styled.div`
   font-size: 20px;
   font-weight: 700;
   color: ${({ theme }) => theme?.colors?.textPrimary ?? '#111'};
`;

function SimpleTable({ columns, rows }) {
   return (
      <table>
         <thead>
            <tr style={{ textAlign: 'left' }}>
               {columns.map((c) => (
                  <th
                     key={c.key}
                     style={{
                        padding: '10px 8px',
                        fontSize: 12,
                        opacity: 0.75,
                     }}
                  >
                     {c.label}
                  </th>
               ))}
            </tr>
         </thead>
         <tbody>
            {rows.map((r, idx) => (
               <tr
                  key={r.id ?? idx}
                  style={{ borderTop: '1px solid rgba(0,0,0,0.08)' }}
               >
                  {columns.map((c) => (
                     <td key={c.key} style={{ padding: '10px 8px' }}>
                        {typeof c.render === 'function'
                           ? c.render(r)
                           : r[c.key]}
                     </td>
                  ))}
               </tr>
            ))}
         </tbody>
      </table>
   );
}

SimpleTable.propTypes = {
   columns: PropTypes.arrayOf(
      PropTypes.shape({
         key: PropTypes.string.isRequired,
         label: PropTypes.node,
         render: PropTypes.func,
      })
   ).isRequired,
   rows: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default function UiShowcasePage() {
   const screens = useMemo(
      () => [
         {
            key: 'stock',
            name: 'Estoque disponível (tabela + filtros)',
            render: ScreenStock,
         },
         {
            key: 'moves',
            name: 'Consulta de movimentos (filtros + tabela)',
            render: ScreenMoves,
         },
         {
            key: 'inv',
            name: 'Inventário (cards + tabela)',
            render: ScreenInventory,
         },
         {
            key: 'products',
            name: 'Gestão de Produtos (form + list)',
            render: ScreenProducts,
         },
         {
            key: 'users',
            name: 'Gestão de usuários (empty + list)',
            render: ScreenUsers,
         },
         {
            key: 'states',
            name: 'Estados (loading / error / empty)',
            render: ScreenStates,
         },
         {
            key: 'moveout',
            name: 'Saída de movimentos (form + itens + tabela)',
            render: ScreenMoveOut,
         },
      ],
      []
   );

   const [idx, setIdx] = useState(0);
   const current = screens[idx];
   const Screen = current.render;

   function prev() {
      setIdx((v) => (v === 0 ? screens.length - 1 : v - 1));
   }

   function next() {
      setIdx((v) => (v === screens.length - 1 ? 0 : v + 1));
   }

   useEffect(() => {
      function onKeyDown(e) {
         if (e.key === 'ArrowLeft') prev();
         if (e.key === 'ArrowRight') next();
      }
      window.addEventListener('keydown', onKeyDown);
      return () => window.removeEventListener('keydown', onKeyDown);
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [screens.length]);

   return (
      <Container $size="lg">
         <NavBar>
            <NavLeft>
               <StepBadge>
                  {idx + 1} / {screens.length}
               </StepBadge>
               <StepTitle title={current.name}>{current.name}</StepTitle>
            </NavLeft>

            <NavRight>
               <Button onClick={prev} aria-label="Página anterior">
                  {'<'}
               </Button>
               <Button onClick={next} aria-label="Próxima página">
                  {'>'}
               </Button>
            </NavRight>
         </NavBar>

         <Divider />

         <Screen />
      </Container>
   );
}

/* ======= SCREENS MOCKADAS ======= */

function ScreenStock() {
   const [query, setQuery] = useState('');
   const [sku, setSku] = useState('');

   const rows = useMemo(() => {
      const base = [
         {
            id: 1,
            name: 'Refil PPF',
            sku: 'PPF-001',
            location: 'Loja Central',
            qty: 12,
         },
         {
            id: 2,
            name: 'Filtro Carbon Block',
            sku: 'CB-120',
            location: 'Depósito',
            qty: 3,
         },
         {
            id: 3,
            name: 'Purificador X',
            sku: 'PX-888',
            location: 'Loja Anápolis',
            qty: 1,
         },
      ];
      const q = query.trim().toLowerCase();
      const s = sku.trim().toLowerCase();
      return base.filter((r) => {
         const okQ = !q || r.name.toLowerCase().includes(q);
         const okS = !s || r.sku.toLowerCase().includes(s);
         return okQ && okS;
      });
   }, [query, sku]);

   const hasFilters = Boolean(query || sku);
   const isEmpty = hasFilters && rows.length === 0;

   return (
      <>
         <PageHeader>
            <PageHeaderText>
               <PageTitle>Estoque disponível</PageTitle>
               <PageSubtitle>
                  Exemplo base (filtros + tabela com overflow no mobile).
               </PageSubtitle>
            </PageHeaderText>
            <PageHeaderActions>
               <Button $variant="outline">Exportar</Button>
            </PageHeaderActions>
         </PageHeader>

         <Section>
            <SectionTitle>Filtros</SectionTitle>

            <ActionBar>
               <ActionBarLeft>
                  <Field label="Nome/descrição">
                     <BaseInput
                        value={query}
                        onChange={(e) => setQuery(e.target.value)}
                        placeholder="Ex.: refil, purificador..."
                     />
                  </Field>

                  <Field label="SKU/Código">
                     <BaseInput
                        value={sku}
                        onChange={(e) => setSku(e.target.value)}
                        placeholder="Ex.: PPF-001"
                     />
                  </Field>
               </ActionBarLeft>

               <ActionBarRight>
                  <Button
                     $variant="outline"
                     onClick={() => {
                        setQuery('');
                        setSku('');
                     }}
                     disabled={!hasFilters}
                  >
                     Limpar
                  </Button>
                  <Button $variant="solid" disabled={!hasFilters}>
                     Aplicar
                  </Button>
               </ActionBarRight>
            </ActionBar>

            {isEmpty ? (
               <EmptyState
                  title="Nenhum resultado"
                  description="Tente ajustar os filtros ou buscar por SKU."
                  action={
                     <Button
                        $variant="solid"
                        onClick={() => {
                           setQuery('');
                           setSku('');
                        }}
                     >
                        Limpar filtros
                     </Button>
                  }
               />
            ) : (
               <TableWrapper $minWidth="760px">
                  <SimpleTable
                     columns={[
                        { key: 'name', label: 'Produto' },
                        { key: 'sku', label: 'SKU' },
                        { key: 'location', label: 'Local' },
                        { key: 'qty', label: 'Disponível' },
                     ]}
                     rows={rows}
                  />
               </TableWrapper>
            )}
         </Section>
      </>
   );
}

function ScreenMoves() {
   const [period, setPeriod] = useState('30');
   const [type, setType] = useState('all');
   const [q, setQ] = useState('');

   const rows = useMemo(() => {
      const base = [
         {
            id: 1,
            date: '2026-01-21',
            type: 'Entrada',
            ref: 'NF 1234',
            by: 'Wander',
            items: 8,
         },
         {
            id: 2,
            date: '2026-01-20',
            type: 'Saída',
            ref: 'OS 5581',
            by: 'Atila',
            items: 3,
         },
         {
            id: 3,
            date: '2026-01-19',
            type: 'Saída',
            ref: 'PV 8821',
            by: 'Telemarketing',
            items: 1,
         },
      ];
      const qq = q.trim().toLowerCase();
      return base.filter((r) => {
         const okType = type === 'all' || r.type.toLowerCase() === type;
         const okQ =
            !qq ||
            r.ref.toLowerCase().includes(qq) ||
            r.by.toLowerCase().includes(qq);
         return okType && okQ;
      });
   }, [q, type]);

   return (
      <>
         <PageHeader>
            <PageHeaderText>
               <PageTitle>Consulta de movimentos</PageTitle>
               <PageSubtitle>Padrão de filtros + tabela.</PageSubtitle>
            </PageHeaderText>
            <PageHeaderActions>
               <Button $variant="solid">Novo movimento</Button>
            </PageHeaderActions>
         </PageHeader>

         <Section>
            <SectionTitle>Filtros</SectionTitle>

            <ActionBar>
               <ActionBarLeft>
                  <Field label="Período">
                     <BaseSelect
                        value={period}
                        onChange={(e) => setPeriod(e.target.value)}
                     >
                        <option value="7">Últimos 7 dias</option>
                        <option value="30">Últimos 30 dias</option>
                        <option value="90">Últimos 90 dias</option>
                     </BaseSelect>
                  </Field>

                  <Field label="Tipo">
                     <BaseSelect
                        value={type}
                        onChange={(e) => setType(e.target.value)}
                     >
                        <option value="all">Todos</option>
                        <option value="entrada">Entrada</option>
                        <option value="saída">Saída</option>
                     </BaseSelect>
                  </Field>

                  <Field label="Buscar por referência/usuário">
                     <BaseInput
                        value={q}
                        onChange={(e) => setQ(e.target.value)}
                        placeholder="Ex.: NF 1234, OS 5581..."
                     />
                  </Field>
               </ActionBarLeft>

               <ActionBarRight>
                  <Button
                     $variant="outline"
                     onClick={() => {
                        setPeriod('30');
                        setType('all');
                        setQ('');
                     }}
                  >
                     Limpar
                  </Button>
                  <Button $variant="solid">Aplicar</Button>
               </ActionBarRight>
            </ActionBar>

            <TableWrapper $minWidth="840px">
               <SimpleTable
                  columns={[
                     { key: 'date', label: 'Data' },
                     { key: 'type', label: 'Tipo' },
                     { key: 'ref', label: 'Referência' },
                     { key: 'by', label: 'Usuário/Origem' },
                     { key: 'items', label: 'Itens' },
                     {
                        key: 'actions',
                        label: 'Ações',
                        render: () => <Button $variant="outline">Abrir</Button>,
                     },
                  ]}
                  rows={rows}
               />
            </TableWrapper>
         </Section>
      </>
   );
}

function ScreenInventory() {
   const cards = [
      { title: 'SKUs ativos', value: '1.248' },
      { title: 'Baixo estoque', value: '34' },
      { title: 'Sem estoque', value: '11' },
      { title: 'Mov. hoje', value: '27' },
   ];

   const rows = [
      {
         id: 1,
         sku: 'PPF-001',
         name: 'Refil PPF',
         qty: 12,
         min: 8,
         status: 'OK',
      },
      {
         id: 2,
         sku: 'CB-120',
         name: 'Carbon Block',
         qty: 3,
         min: 6,
         status: 'Baixo',
      },
      {
         id: 3,
         sku: 'PX-888',
         name: 'Purificador X',
         qty: 0,
         min: 1,
         status: 'Sem estoque',
      },
   ];

   return (
      <>
         <PageHeader>
            <PageHeaderText>
               <PageTitle>Inventário</PageTitle>
               <PageSubtitle>Cards + tabela padronizada.</PageSubtitle>
            </PageHeaderText>
            <PageHeaderActions>
               <Button $variant="solid">Ajuste rápido</Button>
            </PageHeaderActions>
         </PageHeader>

         <Section>
            <SectionTitle>Visão geral</SectionTitle>

            <CardGrid $span={12} $mdSpan={6} $lgSpan={3}>
               {cards.map((c) => (
                  <MiniCard key={c.title}>
                     <MiniCardTitle>{c.title}</MiniCardTitle>
                     <MiniCardValue>{c.value}</MiniCardValue>
                  </MiniCard>
               ))}
            </CardGrid>
         </Section>

         <Section>
            <SectionTitle>Itens críticos</SectionTitle>

            <TableWrapper $minWidth="860px">
               <SimpleTable
                  columns={[
                     { key: 'sku', label: 'SKU' },
                     { key: 'name', label: 'Produto' },
                     { key: 'qty', label: 'Qtd.' },
                     { key: 'min', label: 'Mínimo' },
                     { key: 'status', label: 'Status' },
                     {
                        key: 'actions',
                        label: 'Ações',
                        render: () => (
                           <Button $variant="outline">Detalhes</Button>
                        ),
                     },
                  ]}
                  rows={rows}
               />
            </TableWrapper>
         </Section>
      </>
   );
}

function ScreenProducts() {
   const [mode, setMode] = useState('create'); // create | list
   const [name, setName] = useState('');
   const [sku, setSku] = useState('');
   const [cat, setCat] = useState('Filtros');

   const rows = [
      {
         id: 1,
         sku: 'PPF-001',
         name: 'Refil PPF',
         cat: 'Filtros',
         active: 'Sim',
      },
      {
         id: 2,
         sku: 'PX-888',
         name: 'Purificador X',
         cat: 'Purificadores',
         active: 'Sim',
      },
   ];

   return (
      <>
         <PageHeader>
            <PageHeaderText>
               <PageTitle>Gestão de Produtos</PageTitle>
               <PageSubtitle>
                  Unifica criar/consultar/editar em uma área.
               </PageSubtitle>
            </PageHeaderText>

            <PageHeaderActions>
               <Button $variant="outline" onClick={() => setMode('list')}>
                  Consultar
               </Button>
               <Button $variant="solid" onClick={() => setMode('create')}>
                  Criar
               </Button>
            </PageHeaderActions>
         </PageHeader>

         {mode === 'create' ? (
            <Section>
               <SectionTitle>Novo produto</SectionTitle>

               <FormGrid>
                  <div className="col-8">
                     <Field label="Nome do produto">
                        <BaseInput
                           value={name}
                           onChange={(e) => setName(e.target.value)}
                           placeholder="Ex.: Refil PPF"
                        />
                     </Field>
                  </div>

                  <div className="col-4">
                     <Field label="SKU/Código">
                        <BaseInput
                           value={sku}
                           onChange={(e) => setSku(e.target.value)}
                           placeholder="Ex.: PPF-001"
                        />
                     </Field>
                  </div>

                  <div className="col-4">
                     <Field label="Categoria">
                        <BaseSelect
                           value={cat}
                           onChange={(e) => setCat(e.target.value)}
                        >
                           <option>Filtros</option>
                           <option>Purificadores</option>
                           <option>Peças</option>
                           <option>Serviços</option>
                        </BaseSelect>
                     </Field>
                  </div>

                  <div className="col-4">
                     <Field label="Status">
                        <BaseSelect defaultValue="Ativo">
                           <option>Ativo</option>
                           <option>Inativo</option>
                        </BaseSelect>
                     </Field>
                  </div>

                  <div className="col-4">
                     <Field label="Estoque mínimo">
                        <BaseInput type="number" placeholder="Ex.: 6" />
                     </Field>
                  </div>
               </FormGrid>

               <div
                  style={{
                     display: 'flex',
                     justifyContent: 'flex-end',
                     gap: 8,
                     marginTop: 14,
                  }}
               >
                  <Button $variant="outline">Cancelar</Button>
                  <Button $variant="solid">Salvar</Button>
               </div>
            </Section>
         ) : (
            <Section>
               <SectionTitle>Produtos</SectionTitle>

               <ActionBar>
                  <ActionBarLeft>
                     <Field label="Buscar">
                        <BaseInput placeholder="Nome ou SKU..." />
                     </Field>

                     <Field label="Categoria">
                        <BaseSelect defaultValue="Todas">
                           <option>Todas</option>
                           <option>Filtros</option>
                           <option>Purificadores</option>
                        </BaseSelect>
                     </Field>
                  </ActionBarLeft>

                  <ActionBarRight>
                     <Button $variant="outline">Exportar</Button>
                     <Button $variant="solid">Novo</Button>
                  </ActionBarRight>
               </ActionBar>

               <TableWrapper $minWidth="900px">
                  <SimpleTable
                     columns={[
                        { key: 'sku', label: 'SKU' },
                        { key: 'name', label: 'Produto' },
                        { key: 'cat', label: 'Categoria' },
                        { key: 'active', label: 'Ativo' },
                        {
                           key: 'actions',
                           label: 'Ações',
                           render: () => (
                              <Button $variant="outline">Editar</Button>
                           ),
                        },
                     ]}
                     rows={rows}
                  />
               </TableWrapper>
            </Section>
         )}
      </>
   );
}

function ScreenUsers() {
   const [hasUsers, setHasUsers] = useState(false);

   const rows = [
      { id: 1, name: 'Caio', role: 'Admin', status: 'Ativo' },
      { id: 2, name: 'Wander', role: 'Supervisor', status: 'Ativo' },
   ];

   return (
      <>
         <PageHeader>
            <PageHeaderText>
               <PageTitle>Gestão de usuários</PageTitle>
               <PageSubtitle>Exemplo com EmptyState e tabela.</PageSubtitle>
            </PageHeaderText>

            <PageHeaderActions>
               <Button $variant="solid">Novo usuário</Button>
            </PageHeaderActions>
         </PageHeader>

         <Section>
            <SectionTitle>Usuários</SectionTitle>

            <ActionBar>
               <ActionBarLeft>
                  <Field label="Buscar">
                     <BaseInput placeholder="Nome, email..." />
                  </Field>

                  <Field label="Perfil">
                     <BaseSelect defaultValue="Todos">
                        <option>Todos</option>
                        <option>Admin</option>
                        <option>Supervisor</option>
                        <option>Expedidor</option>
                     </BaseSelect>
                  </Field>
               </ActionBarLeft>

               <ActionBarRight>
                  <Button
                     $variant="outline"
                     onClick={() => setHasUsers((v) => !v)}
                  >
                     Toggle empty
                  </Button>
               </ActionBarRight>
            </ActionBar>

            {!hasUsers ? (
               <EmptyState
                  title="Nenhum usuário encontrado"
                  description="Ajuste os filtros ou cadastre um novo usuário."
                  action={<Button $variant="solid">Cadastrar</Button>}
               />
            ) : (
               <TableWrapper $minWidth="820px">
                  <SimpleTable
                     columns={[
                        { key: 'name', label: 'Nome' },
                        { key: 'role', label: 'Perfil' },
                        { key: 'status', label: 'Status' },
                        {
                           key: 'actions',
                           label: 'Ações',
                           render: () => (
                              <Button $variant="outline">Editar</Button>
                           ),
                        },
                     ]}
                     rows={rows}
                  />
               </TableWrapper>
            )}
         </Section>
      </>
   );
}

function ScreenStates() {
   const [mode, setMode] = useState('loading'); // loading | error | empty | ok

   return (
      <>
         <PageHeader>
            <PageHeaderText>
               <PageTitle>Estados padrão</PageTitle>
               <PageSubtitle>
                  Simula loading/error/empty dentro do layout.
               </PageSubtitle>
            </PageHeaderText>

            <PageHeaderActions>
               <Button $variant="outline" onClick={() => setMode('loading')}>
                  Loading
               </Button>
               <Button $variant="outline" onClick={() => setMode('error')}>
                  Error
               </Button>
               <Button $variant="outline" onClick={() => setMode('empty')}>
                  Empty
               </Button>
               <Button $variant="solid" onClick={() => setMode('ok')}>
                  OK
               </Button>
            </PageHeaderActions>
         </PageHeader>

         <Section>
            <SectionTitle>Conteúdo</SectionTitle>

            {mode === 'loading' ? (
               <div style={{ padding: 12, opacity: 0.75 }}>Carregando…</div>
            ) : mode === 'error' ? (
               <ErrorState
                  title="Falha ao carregar dados"
                  description="Exemplo de estado de erro com ação."
                  action={<Button $variant="solid">Tentar novamente</Button>}
               />
            ) : mode === 'empty' ? (
               <EmptyState
                  title="Nada por aqui"
                  description="Exemplo de estado vazio padronizado."
                  action={<Button $variant="solid">Criar novo</Button>}
               />
            ) : (
               <div style={{ padding: 12 }}>
                  Conteúdo OK: aqui entraria tabela, cards, formulários etc.
               </div>
            )}
         </Section>
      </>
   );
}

function ScreenMoveOut() {
  // Mock de “DB”
  const catalog = useMemo(
    () => ({
      "PPF-001": "Refil PPF",
      "CB-120": "Filtro Carbon Block",
      "PX-888": "Purificador X",
      "EV-ICE": "Máquina de Gelo Everest",
    }),
    []
  );

  const pdvs = useMemo(
    () => [
      "Matriz Goiânia",
      "Depósito 2 (Goiânia)",
      "Loja Anápolis",
      "Assistência Técnica",
      "Marketplace (Central)",
    ],
    []
  );

  const docTypes = useMemo(
    () => ["Nota Fiscal", "Transferência", "Ajuste", "Devolução de venda", "Pedido de venda"],
    []
  );

  const [pdv, setPdv] = useState(pdvs[0]);
  const [docType, setDocType] = useState(docTypes[4]);
  const [desc, setDesc] = useState("");

  const [sku, setSku] = useState("");
  const [productName, setProductName] = useState("");
  const [qty, setQty] = useState("1");
  const [lookupMsg, setLookupMsg] = useState(""); // feedback de busca do SKU

  const [items, setItems] = useState([]);

  function handleSearchSku() {
    const key = sku.trim().toUpperCase();
    if (!key) {
      setLookupMsg("Informe um SKU para pesquisar.");
      setProductName("");
      return;
    }

    const found = catalog[key];
    if (!found) {
      setLookupMsg("SKU não encontrado no DB (mock).");
      setProductName("");
      return;
    }

    setLookupMsg("SKU encontrado ✅");
    setProductName(found);
  }

  function handleAddItem() {
    const key = sku.trim().toUpperCase();
    const q = Number(qty);

    if (!key) return setLookupMsg("Informe um SKU.");
    if (!productName) return setLookupMsg("Pesquise o SKU antes de adicionar.");
    if (!q || q <= 0) return setLookupMsg("Quantidade inválida.");

    setItems((prev) => {
      const existingIdx = prev.findIndex((it) => it.sku === key);
      if (existingIdx >= 0) {
        const copy = [...prev];
        copy[existingIdx] = { ...copy[existingIdx], qty: copy[existingIdx].qty + q };
        return copy;
      }
      return [...prev, { id: `${key}-${Date.now()}`, sku: key, name: productName, qty: q }];
    });

    setLookupMsg("");
    setSku("");
    setProductName("");
    setQty("1");
  }

  function handleRemove(id) {
    setItems((prev) => prev.filter((it) => it.id !== id));
  }

  function handleClearAll() {
    setDesc("");
    setSku("");
    setProductName("");
    setQty("1");
    setLookupMsg("");
    setItems([]);
  }

  const canSave = items.length > 0;

  return (
    <>
      <PageHeader>
        <PageHeaderText>
          <PageTitle>Saída de movimentos</PageTitle>
          <PageSubtitle>
            Exemplo de tela: dados gerais + inclusão de itens por SKU + tabela + ações de salvamento.
          </PageSubtitle>
        </PageHeaderText>

        <PageHeaderActions>
          <Button $variant="outline" onClick={handleClearAll}>
            Limpar tudo
          </Button>
        </PageHeaderActions>
      </PageHeader>

      {/* Dados da saída */}
      <Section>
        <SectionTitle>Dados da saída</SectionTitle>

        <FormGrid>
          <div className="col-4">
            <Field label="PDV">
              <BaseSelect value={pdv} onChange={(e) => setPdv(e.target.value)}>
                {pdvs.map((p) => (
                  <option key={p} value={p}>
                    {p}
                  </option>
                ))}
              </BaseSelect>
            </Field>
          </div>

          <div className="col-4">
            <Field label="Tipo de documento">
              <BaseSelect value={docType} onChange={(e) => setDocType(e.target.value)}>
                {docTypes.map((t) => (
                  <option key={t} value={t}>
                    {t}
                  </option>
                ))}
              </BaseSelect>
            </Field>
          </div>

          <div className="col-8">
            <Field label="Descrição da saída">
              <BaseInput
                value={desc}
                onChange={(e) => setDesc(e.target.value)}
                placeholder="Ex.: saída para entrega, ajuste por avaria, transferência..."
              />
            </Field>
          </div>
        </FormGrid>
      </Section>

      {/* Inclusão de produto */}
      <Section>
        <SectionTitle>Incluir produto</SectionTitle>

        <ActionBar>
          <ActionBarLeft>
            <Field label="SKU">
              <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                <BaseInput
                  value={sku}
                  onChange={(e) => setSku(e.target.value)}
                  placeholder="Ex.: PPF-001"
                  style={{ minWidth: 220 }}
                />
                <Button $variant="outline" type="button" onClick={handleSearchSku}>
                  Pesquisar no DB
                </Button>
              </div>
            </Field>

            <Field label="Nome Produto">
              <BaseInput value={productName} disabled placeholder="Carregado após pesquisar o SKU" />
            </Field>

            <Field label="Quantidade">
              <BaseInput
                type="number"
                min="1"
                value={qty}
                onChange={(e) => setQty(e.target.value)}
                style={{ maxWidth: 140 }}
              />
            </Field>
          </ActionBarLeft>

          <ActionBarRight>
            <Button $variant="solid" type="button" onClick={handleAddItem}>
              Adicionar item
            </Button>
          </ActionBarRight>
        </ActionBar>

        {lookupMsg ? (
          <div style={{ fontSize: 12, opacity: 0.8, padding: "6px 2px" }}>{lookupMsg}</div>
        ) : null}

        {items.length === 0 ? (
          <EmptyState
            title="Nenhum item inserido"
            description="Pesquise um SKU, informe a quantidade e clique em “Adicionar item”."
          />
        ) : (
          <TableWrapper $minWidth="920px">
            <SimpleTable
              columns={[
                { key: "sku", label: "SKU" },
                { key: "name", label: "Nome Produto" },
                { key: "qty", label: "Quantidade" },
                {
                  key: "actions",
                  label: "Ações",
                  render: (row) => (
                    <Button $variant="outline" type="button" onClick={() => handleRemove(row.id)}>
                      Remover
                    </Button>
                  ),
                },
              ]}
              rows={items}
            />
          </TableWrapper>
        )}
      </Section>

      {/* Ações */}
      <Section>
        <SectionTitle>Ações</SectionTitle>

        <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, flexWrap: "wrap" }}>
          <Button $variant="outline" type="button">
            Cancelar
          </Button>
          <Button $variant="outline" type="button" disabled={!canSave}>
            Salvar e limpar
          </Button>
          <Button $variant="solid" type="button" disabled={!canSave}>
            Salvar saída
          </Button>
        </div>

        {!canSave ? (
          <div style={{ marginTop: 8, fontSize: 12, opacity: 0.75 }}>
            Dica: para habilitar “Salvar”, insira pelo menos 1 item na tabela.
          </div>
        ) : null}
      </Section>
    </>
  );
}
